<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <p>
      <span class="label">店铺ID：</span><span class="value">{{ this.$route.params.id }}</span>
      <span class="label">店铺名字：</span><span class="value">{{ detail.vendorName }}</span>
    </p>
    <p class="mt20">接口配置：
      <el-radio-group v-model="interfaceSwitch">
        <!-- <el-radio :label="0">关闭接口权限</el-radio> -->
        <el-radio :label="1">打开接口权限</el-radio>
        <el-radio :label="2">禁止访问所有接口</el-radio>
      </el-radio-group>
    </p>
    <p v-if="interfaceSwitch === 0">接口权限关闭后，所有接口不受此权限控制，全部可以访问</p>
    <p v-if="interfaceSwitch === 1">接口权限打开后，仅勾选过的接口，可以访问，其他接口，不可以访问</p>
    <template v-for="g in apiList">
      <p class="group-name" :key="g.name">{{ g.name }}</p>
      <p class="api-item" v-for="item in g.list" :key="item.interfaceConfigurationId">
        <el-checkbox v-model="item.status" :disabled="item.interfaceType === 1 || item.interfaceType === 2 || item.interfaceType === 3" :true-label="1" :false-label="0">{{ item.description }}</el-checkbox>
        <span class="api-url">{{ item.imInterfaceUrl }}</span>
      </p>
    </template>
    <el-button class="submit-btn mt20" type="primary" @click="submit">提交</el-button>
  </div>
</template>

<script>
import {
  getBoutiqueInformation,
  getDockingInfo,
  saveDockingInfo,
} from "./api";

export default {
  data() {
    return {
      fullscreenLoading: false,
      detail: {},
      interfaceSwitch: null,
      groupMap: {
        1: 'open api 1.0.0',
        2: 'open api 1.2.0',
        3: 'open api 1.3.0',
        4: 'IM拉取',
      },
      apiList: [],
    };
  },
  mounted() {
    getBoutiqueInformation(this.$route.params.id).then(res => {
      this.detail = res.data.data || {};
    });
    this.getDockingInfo();
  },
  methods: {
    getDockingInfo() {
      this.fullscreenLoading = true;
      getDockingInfo({
        vendorId: this.$route.params.id,
      }).then(res => {
        if (res.data && res.data.data) {
          this.interfaceSwitch = res.data.data.interfaceSwitch;
          const typeMap = {};
          res.data.data.interfaceConfigurationDtoList.forEach(item => {
            if (!typeMap[item.interfaceType]) {
              typeMap[item.interfaceType] = [];
            }
            typeMap[item.interfaceType].push(item);
          })
          const keyArr = [];
          for (let key in typeMap) {
            if(typeMap.hasOwnProperty(key)) {
              keyArr.push(key);
            }
          }
          keyArr.sort();
          this.apiList = keyArr.map(key => {
            return {
              name: this.groupMap[key],
              list: typeMap[key],
            }
          })
          this.fullscreenLoading = false;
        }
      })
    },
    submit() {
      this.fullscreenLoading = true;
      let ids = [];
      this.apiList.forEach(g => {
        const idarr = g.list.filter(item => item.status).map(item => item.interfaceConfigurationId);
        ids = ids.concat(idarr)
      })
      saveDockingInfo({
        vendorId: this.$route.params.id,
        interfaceSwitch: this.interfaceSwitch,
        interfaceConfigurationIdList: ids,
      }).then(res => {
        if (res.data.code == '200') {
          this.$message.success('更新成功');
          this.getDockingInfo();
        }
      })
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.mt20 {
  margin-top: 20px;
}
.label {
  color: #999;
  font-size: 16px;
}
.value {
  margin-right: 20px;
  font-size: 16px;
}
.group-name {
  margin-top: 20px;
  margin-bottom: 5px;
  font-size: 20px;
}
.api-url {
  display: none;
  margin-left: 20px;
  font-size: 14px;
}
.api-item {
  display: flex;
  flex-wrap: wrap;
  padding-left: 20px;

  &:hover .api-url {
    display: block;
  }
}
.submit-btn {
  position: fixed;
  top: 100px;
  left: 800px;
}
</style>
